import React, { useRef, useEffect, useState  } from 'react';
import Plotly from 'plotly.js-dist';
import { RESET_THREE_D_VIEW_LAYOUT} from "../../utils/graph-layouts";

export const Graph = ({ data, layout, config, onRelayout = null }) => {
  const plotRef = useRef(null);
  const [plotInstance, setPlotInstance] = useState(null); // Store the Plot instance

  useEffect(() => {
    let isMounted = true;
    let currentPlot;

    if(onRelayout === '3d') {
      let layout = RESET_THREE_D_VIEW_LAYOUT;
      layout.scene.camera.eye.x = -2.75;
      layout.scene.camera.eye.y = -2.75;
      layout.scene.camera.eye.z = 2.75;
      Plotly.react(plotRef.current, data, layout, config).then((instance) => {
        if (isMounted) {
          currentPlot = instance;
          setPlotInstance(instance);
        }
      })
      .catch((error) => {
        console.error("Error creating plot:", error);
      });
      Plotly.redraw(plotRef.current); // Force a redraw to reflect the updates
    } else {
      Plotly.newPlot(plotRef.current, data, layout, config)
      .then((instance) => {
        if (isMounted) {
          currentPlot = instance;
          setPlotInstance(instance);
        }
      })
      .catch((error) => {
        console.error("Error creating plot:", error);
      });
    }
    return () => {
      isMounted = false; // Set to false on unmount
      if (plotRef.current !== null) {
        Plotly.purge(plotRef.current);
        setPlotInstance(null); // Clear the reference
      }
    };
  }, [data, layout, config]);

  return <div ref={plotRef} style={{ width: '100%', height: '100%' }} />;
};
